export default __webpack_public_path__ + "static/media/whiteInstagram.e3bf67f8.svg";